import { useLazyQuery } from "@apollo/client/react";
import { Typography } from "@mui/material";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { CustomDialog } from "../../../../components/customDialog/CustomDialog";
import DataGridGenerico from "../../../../components/dataGrid/DataGridGenerico";
import { GET_DETALLE_LIQUIDACION } from "../../../../data/graphQL/queries/PreLiquidacion/getDetalleLiquidacion";
import { useGetColumnsLiquidacionesPendientes } from "../../hooks/useGetColumnsLiquidacionesPendientes";

export const DialogLiquidacionesPendiente = ({
    open,
    setOpen,
    liquidacion,
    mes,
    anio,
    onConfirmar,
    profesionales,
    loading: loadingAprobacion
}) => {
    const columns = useGetColumnsLiquidacionesPendientes();

    const [getDetalle, { loading, error }] = useLazyQuery(GET_DETALLE_LIQUIDACION, {
        fetchPolicy: 'no-cache'
    });

    useEffect(() => {
        if (!open || !liquidacion?.idEvaluacion || !liquidacion?.idProfesional) return;

        getDetalle({
            variables: {
                idEvaluacion: liquidacion.idEvaluacion,
                idProfesional: liquidacion.idProfesional,
                mes,
                anio,
                idEvaluacionProfesional: liquidacion?.idEvaluacionProfesional,
                liquidacionFinal: true
            }
        });
    }, [open, liquidacion, mes, anio, getDetalle]);

    useEffect(() => {
        if (!error) return;
        toast.error('No se pudo cargar el detalle de la liquidación.');
    }, [error]);


    return (
        <CustomDialog
            open={open}
            fullWidth
            boldDialogTitle
            maxWidth='sm'
            dialogTitle='Existen profesionales con liquidaciones pendientes'
            onCancel={() => setOpen(false)}
            onAccept={onConfirmar}
            cancelText='Cancelar'
            acceptText='Liquidar'
            acceptLoading={loadingAprobacion}
            cancelDisabled={loadingAprobacion}
            onBackdropClick={loadingAprobacion ? () => { } : null} //Si está cargando, no permitir cerrar haciendo click fuera del diálogo
        >
            <Typography sx={{ mb: 2, fontSize: '0.95rem', color: 'text.secondary' }}>
                Si usted presiona "Liquidar" los contratos de los profesionales pendientes a liquidar serán rechazados de manera automática.
            </Typography>
            <DataGridGenerico
                columns={columns}
                rows={profesionales}
                loading={loading}
                hideFooter
            />
        </CustomDialog>
    );
};